<template>
  <div class="big-idea-page">

    <header-bar process="signup"></header-bar>

    <section class="big-idea">
      <div class="grid-container">
        <div class="row">
          <div class="col-6">
            <div class="image-circle">
              <img v-if="this.$root.profilereg.profileimg === 'default'" src="https://firebasestorage.googleapis.com/v0/b/pei-exchange.appspot.com/o/profile-images%2Fdefaultimg1.jpg?alt=media&token=1704a992-1ea9-4c8d-a8c5-e4c59803155f" />
                <img v-else :src="this.$root.profilereg.profileimg" />
            </div>
            <div class="info">
              <h4>{{ this.$root.profilereg.firstname + ' ' + this.$root.profilereg.surname }}</h4>
<!--               <span class="reputation">{{ this.$root.userrep['.value'] }}</span> -->
              <h5>{{ this.$root.profilereg.jobtitle }}</h5>
              <span class="location">{{ this.$root.profilereg.location }}</span>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-6">
            <label>(Optional) Do you have a big idea for Africa {{ this.$root.profilereg.firstname }}?</label>
            <a class="link-simple" v-on:click.stop.prevent="addExample">View Example</a>
            <textarea id="bigIdea" rows="4" v-model.trim="bigIdea" placeholder="My big idea for africa is...">{{ this.bigIdea }}</textarea>
          </div>
        </div>
      </div>
    </section>

    <section class="sign-up-navigation">
      <div class="grid-container">
        <a href="#" v-on:click.stop.prevent="stepBack" class="link-back">Change your skills</a>
        <a href="#" v-on:click.stop.prevent="progress" class="btn btn-big bg-four active">Next</a>
      </div>
    </section>
  </div>
</template>

<script>
import { db } from '@/firebase'
import HeaderBar from '@/components/HeaderBar'

export default {
  name: 'Register',
  components: {
    HeaderBar
  },
  data () {
    return {
      bigIdea: this.bigIdea
    }
  },
  methods: {
    stepBack () {
      this.$parent.currentStep--
    },
    progress () {
      let parent = this
      let user = this.$root.user.uid
      this.$parent.bigIdea = this.bigIdea

      if (this.$parent.bigIdea) {
        db.ref('users-registration/' + user).update({
          bigidea: this.$parent.bigIdea
        }, function () {
          // On complete
          console.log('saved')
          parent.$parent.currentStep++
        })
      } else {
        this.$parent.currentStep++
      }
    },
    addExample () {
      let example = 'My big idea for Africa is to use mobile technology and micro-finance to empower women in rural areas and enable them to uplift their families from endemic poverty.'
      this.bigIdea = example
    }
  }
}
</script>



// WEBPACK FOOTER //
// Register-Step-8.vue?78db6de9